module.exports = __webpack_public_path__ + "img/Image_05.a8e653a9.jpg";